



import { Vue, Component } from "vue-property-decorator";

import ProductList from "@/components/admin/productList.vue";

@Component({
  name: "Items",
  components: {
    ProductList,
  },
})
export default class Items extends Vue {}
